import { Injectable } from '@angular/core';
import { Feathers } from './feathers.service';
import { Observable } from 'rxjs';
import { MongoDbModel } from './MongoDbModel';
import { Params } from '@angular/router';
import { Id, NullableId } from '@feathersjs/feathers';

export interface Gateway {
  _id?: string;
  name?: string;
  connectionUrl?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GatewayService {
  constructor(private feathers: Feathers) { }


  service = this.feathers.service('gateways');

  // create observables to allow for realtime data updates
  private _patch$ = new Observable<{gateway: Gateway & MongoDbModel, params: Params}>(subscriber => {
    this.service.on('patched', (gateway, params) => subscriber.next({gateway, params}));
  });

  private _create$ = new Observable<{gateway: Gateway & MongoDbModel, params: Params}>(subscriber => {
    this.service.on('created', (gateway, params) => subscriber.next({gateway, params}));
  });

  private _remove$ = new Observable<{gateway: Gateway & MongoDbModel, params: Params}>(subscriber => {
    this.service.on('removed', (gateway, params) => subscriber.next({gateway, params}));
  });

  get patch$() {
    return this._patch$;
  }

  get create$() {
    return this._create$;
  }

  get remove$() {
    return this._remove$;
  }

  async get(id: Id, params?: Params): Promise<Gateway> {
    return this.service.get(id, params);
  }

  async create(data: Gateway, params?: Params): Promise<Gateway> {
    return this.service.create(data, params);
  }

  async patch(id: NullableId, data: any, params?: Params): Promise<Gateway> {
    return this.service.patch(id, data, params);
  }

  async remove(id: NullableId, params?: Params): Promise<Gateway> {
    return this.service.remove(id, params);
  }

  async find(params?: Params) {
    const res = await this.service.find(params);
    return res;
  }
}
